import React from "react";
import { MapPin, Phone, Mail, Facebook, ExternalLink } from "lucide-react";

const FooterEN = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-[#1C3A27] text-white" role="contentinfo">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="py-12 md:py-16">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8">
            <div className="lg:col-span-2">
              <h3 className="font-serif text-2xl font-bold mb-4">
                Hearts of Normandy
              </h3>
              <p className="text-white/80 mb-6 leading-relaxed">
                Charming gîte in Norman Switzerland, up to 10 people. 
                Discover authentic and welcoming accommodation in the heart of Norman nature.
              </p>
              <div className="flex items-center text-sm text-white/70 mb-2">
                <span className="font-medium">Clévacances – 3 keys</span>
              </div>
              <div className="text-sm text-white/70">
                Nathalie & Wilhelm Martel, owners
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-lg mb-4">Contact</h4>
              <div className="space-y-3">
                <div className="flex items-start">
                  <MapPin size={16} className="mr-2 mt-0.5 flex-shrink-0 text-white/70" />
                  <span className="text-sm text-white/80">
                    31 Rue Notre-Dame<br />
                    14570 Clécy, France
                  </span>
                </div>
                <a
                  href="mailto:wilhelm.martel@orange.fr"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Send email to wilhelm.martel@orange.fr"
                >
                  <Mail size={16} className="mr-2 flex-shrink-0" />
                  wilhelm.martel@orange.fr
                </a>
                <a
                  href="https://www.facebook.com/profile.php?id=100089881764871"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Follow on Facebook - Opens in new tab"
                  title="Hearts of Normandy Facebook page"
                >
                  <Facebook size={16} className="mr-2 flex-shrink-0" />
                  Facebook
                </a>
              </div>
            </div>

            <div>
              <h4 className="font-semibold text-lg mb-4">Bookings</h4>
              <div className="space-y-3">
                <a
                  href="https://www.airbnb.fr/rooms/1124426465764074190"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Book on Airbnb - Opens in new tab"
                  title="Book directly on Airbnb"
                >
                  <ExternalLink size={16} className="mr-2 flex-shrink-0" />
                  Airbnb
                </a>
                <a
                  href="https://www.booking.com/hotel/fr/gite-au-coeur-de-la-suisse-normande.fr.html"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center text-sm text-white/80 hover:text-white transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                  aria-label="Book on Booking.com - Opens in new tab"
                  title="Book directly on Booking.com"
                >
                  <ExternalLink size={16} className="mr-2 flex-shrink-0" />
                  Booking.com
                </a>
                <div className="text-sm text-white/70 mt-4">
                  Or contact us directly for a personalized booking
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-white/20"></div>

        <div className="py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <div className="text-sm text-white/70 text-center md:text-left">
              <p>© {currentYear} Hearts of Normandy. All rights reserved.</p>
              <p className="mt-1">
                Charming gîte • Clécy, Norman Switzerland • Clévacances 3 keys
              </p>
            </div>

            <div className="text-center">
              <p className="text-xs text-white/50">
                Site created by{" "}
                <a
                  href="https://vibesite.fr"
                  target="_blank"
                  rel="noopener noreferrer"
                  title="Web site creation for exceptional accommodations"
                  aria-label="Link to Vibesite, web agency specialized in exceptional accommodations"
                  className="text-white/70 hover:text-white transition-colors duration-200 underline hover:no-underline focus:outline-none focus:ring-2 focus:ring-white focus:ring-offset-2 focus:ring-offset-[#1C3A27] rounded-sm"
                >
                  Vibesite.fr
                </a>
                {" "}— Web site creation for exceptional accommodations
              </p>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default FooterEN;